import * as React from "react";
// import { Link } from "gatsby"

import Layout from "../components/layout";
import HeroSection from "../components/OurServices/HeroSection";
import Logistics from "../components/OurServices/Logistics";
import Seo from "../components/seo";

const OurServices = () => (
  <Layout>
    <Seo title="Our Services" />
    <HeroSection />
    <Logistics />
  </Layout>
);

export default OurServices;
